// Some advertising images are stored by the backend with an http:// URL,
// which triggers mixed-content warnings on the https:// site. Upgrade the
// scheme client-side until the backend stores https:// URLs directly.
export function toHttps(url) {
  if (typeof url !== "string") return url;
  return url.replace(/^http:\/\//i, "https://");
}
